//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SiteComplianceFooter from './SiteComplianceFooter';
import conf from "../config/base.js";
const TERMINATED = 1, REDIRECT = 2;

export default {
  name: "DisableTip",
  data() {
    return {
			source: localStorage.getItem('source'),
      isDev: conf.envType !== 'PROD',
      redirectUrl: conf.envType === 'PROD' ? 'https://x-mobile.xforceplus.com' : 'https://x-mobile-s.xforceplus.com'
    }
  },
  props: {
    sourceFlag: Number,
    isDelay: Boolean
  },
  components: {
    SiteComplianceFooter
  }
};
